import {
    Component,
    Input,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { faTrain } from '@fortawesome/pro-solid-svg-icons';
import { RtUnitTrainSummaryGridService } from '../rt-unit-train-summary-grid.service';
import { RtTripRefFieldDef, RtvUnitTrainTrip } from '@bds/railtrac-models';
import { RailtracTripService, RtTripRefFieldDefService } from '@bds/railtrac';
import { faNavicon } from '@fortawesome/pro-duotone-svg-icons';
import { Observable } from 'rxjs';

@Component({
    selector: 'rt-unit-train-details',
    templateUrl: './rt-unit-train-details.component.html',
    styleUrls: ['./rt-unit-train-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RtUnitTrainDetailsComponent implements OnChanges {
    @Input() unitTrainList: any[] = [];
    @Input() count = 0;

    iconTrain = faTrain;
    iconNavicon = faNavicon;
    unitTrain: RtvUnitTrainTrip | undefined;
    tripIds: number[] = [];
    tripRefFieldDefs$: Observable<RtTripRefFieldDef[]>;
    showShipments = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private unitTrainService: RtUnitTrainSummaryGridService,
        private tripService: RailtracTripService,
        private refFieldDefService: RtTripRefFieldDefService,
    ) {
        this.tripRefFieldDefs$ = this.refFieldDefService.getReferenceFieldDefs();
    }

    get selectedUnitTrain(): any {
        return this.unitTrainList?.[0];
    }

    getUnitTrainDetails() {
        if (!this.unitTrainList || this.unitTrainList.length === 0) {
            this.unitTrain = undefined;
            return;
        }
        this.tripIds = [];
        this.showShipments = false;

        this.unitTrain = this.unitTrainList[0];
        if (this.unitTrain) {
            this.tripService
                .findCurrentTripsInUnitTrain(this.unitTrain?.unitTrainId.trim())
                .subscribe((trips) => {
                    if (trips && trips.length > 0) {
                        this.tripIds = trips
                            .filter(
                                (trip) =>
                                    trip?.locationCity === this.unitTrain?.locCity &&
                                    trip?.locationState === this.unitTrain?.locState &&
                                    trip?.originCity === this.unitTrain?.origCity &&
                                    trip?.originState === this.unitTrain?.origState &&
                                    trip?.destinationCity === this.unitTrain?.destCity &&
                                    trip?.destinationState === this.unitTrain?.destState &&
                                    trip.customerNo === this.unitTrain?.custNo &&
                                    trip.loadEmpty === this.unitTrain?.le,
                            )
                            .map((trip) => trip.ormId)
                            .filter((id): id is number => id !== undefined);
                        this.cdr.markForCheck();
                        this.showShipments = true;
                    }
                });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['unitTrainList']) {
            this.cdr.markForCheck();
            this.getUnitTrainDetails();
        }
    }
}
